export default {
    loading: false,
    params: {
        state: true
    },
    paramsFile: {},
    ag_grid: {
        selectedTheme: "ag-theme-balham"
    },
    productsPrices: [],
    columnsPrices: [],
    isShoppingRole: false,
    allColumns: []
};



// WEBPACK FOOTER //
// ./src/modules/product-pricing/state.js